import styled from "styled-components";

export default styled.div`

&
{
  width: 100%;

  > div{
    width: auto;
    height: 100%;
    margin-left: 20px;
  }
}

h1{
  font-size: 28px;
  font-weight: 400;
  text-align: center;
}

label, .fileInput{
  width: 100px;
  margin: 0px;
  padding: 0px;
}

form > div{
  margin-top: 5px;
  margin-bottom: 5px;
}

button {
  border-radius: 0;
}

input[type='file'] {
  display: none;
}

.largeInput
{
  width: calc(100% - 10px);
}

.multipleFileUpload{
  display: flex;
  width: calc(100% - 10px);
  margin: 0;
  flex-direction: column;
  align-items: flex-start;
  border: 2px solid ${props => props.theme.colors.blue};
}
#dragTitle{
  display: flex;
  margin: 10px 0px 10px 0px;
  justify-content: center;
  align-items: center;
  align-self: center;
  color: ${props => props.theme.colors.black};
}

#gallery{
  width: calc(100% - 20px);
  height: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin: 0px 10px 10px 10px;
  margin-left: auto;
  margin-right: auto;
  gap: 10px;

}

#uploadFile{
  background-color: ${props => props.theme.colors.blue};
  color:  ${props => props.theme.colors.white};

  padding-top: 28.125%;
  padding-bottom: 28.125%;
}

.activeContainer
{
  background-color: ${props => props.theme.colors.blue_light};
}
.invalidDrag{
  background-color: ${props => props.theme.colors.pink};
}
#photoPreview{
  position: relative;
  img{
    width: 100%;
  }
  #removePhoto{
    position: absolute;
    background-color: ${props => props.theme.colors.primary};
    width: 20px;
    height: 20px;
    right: 0px;
    padding: 0;
  }
}

`